import config from './general';

export default config;
